import React from 'react'
import NavBar from '../Components/Main/NavBar';
import Footer from '../Components/Main/Footer';

const Sendback = () => {
  return(
    <div>
        <NavBar/>
        <div style={{
            margin: "50px 200px"
        }}>
            <h1 style={{
                textAlign: "center",
                marginBottom: "50px"
            }}>Visszaküldés és visszatérítés</h1>
            <p>Minden termékünk új, bontatlan csomagolásban kerül kiszállításra. A vásárló a termék átvételétől számított 14
napon belül jogosult a termék visszaküldésére postai úton. A visszaküldéshez szükséges címke (Return label)
beszerzése az ügyfél felelőssége, azonban a termék visszaküldésével kapcsolatban nincs raktári visszapótlási díj
(restocking fee). A visszaküldött termék beérkezését követően a vételárat a vásárló által használt fizetési módon,
legkésőbb 30 napon belül visszatérítjük, feltéve, hogy a termék sértetlen, teljes és az eredeti csomagolásában
található minden tartozékkal együtt került visszaküldésre.</p>
        </div>
        <Footer/>
    </div>
  )
}

export default Sendback